"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESET_HISTORICAL_SYNC = exports.POST_HP_VIEW_CONFIG = exports.POST_HP_ENTRY = exports.GET_PATIENT_HP_ONBOARDING_DATA = exports.GET_ONBOARDING_SYNC = exports.GET_HP_VIEW_CONFIG = exports.GET_HP_VIEW_ALL_DATA = exports.GET_HP_SUMMARY = exports.GET_HP_ONBOARDING_DATA = exports.GET_HP_HEALTH_FEED = exports.GET_HISTORICAL_SYNC_TIMESTAMP = exports.GET_FIRST_TIME_ACCESS = exports.DELETE_HP_ENTRY = void 0;
const GET_HP_ONBOARDING_DATA = exports.GET_HP_ONBOARDING_DATA = 'getHPOnboardingData';
const GET_HP_HEALTH_FEED = exports.GET_HP_HEALTH_FEED = 'getHPHealthFeed';
const POST_HP_ENTRY = exports.POST_HP_ENTRY = 'postHPEntry';
const GET_PATIENT_HP_ONBOARDING_DATA = exports.GET_PATIENT_HP_ONBOARDING_DATA = 'getPatientWiseHPOnboardingData';
const GET_FIRST_TIME_ACCESS = exports.GET_FIRST_TIME_ACCESS = 'getFirstTimeAccess';
const DELETE_HP_ENTRY = exports.DELETE_HP_ENTRY = 'deleteHPEntry';
const GET_HP_VIEW_ALL_DATA = exports.GET_HP_VIEW_ALL_DATA = 'getHPViewAllData';
const GET_ONBOARDING_SYNC = exports.GET_ONBOARDING_SYNC = 'getOnboardingSync';
const GET_HP_SUMMARY = exports.GET_HP_SUMMARY = 'getHpSummary';
const RESET_HISTORICAL_SYNC = exports.RESET_HISTORICAL_SYNC = 'resetHistoricalSync';
const GET_HISTORICAL_SYNC_TIMESTAMP = exports.GET_HISTORICAL_SYNC_TIMESTAMP = 'getHistoricalSyncTimestamp';
const GET_HP_VIEW_CONFIG = exports.GET_HP_VIEW_CONFIG = 'getHpViewConfig';
const POST_HP_VIEW_CONFIG = exports.POST_HP_VIEW_CONFIG = 'postHpViewConfig';